import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const base = "new-equity/";
const revamp = config.revamp;
const commonConfigURL = {
    sidebar: config.jmw + revamp + config.jmw_content + base + "scrip",
    web_config_access_reports: config.oldWebUrl + config.web_config_access_reports,
};
export default commonConfigURL;
